import { route as selfServeRoute } from "@faire/web-api/routes/support/self-serve";
import { route as selfServeTopicsRoute } from "@faire/web-api/routes/support/self-serve/topics";
import { useLocation } from "react-router-dom";
export var useIsSelfServeHomePage = function useIsSelfServeHomePage() {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  if (pathname === selfServeRoute || pathname === selfServeTopicsRoute) {
    return true;
  }
  return false;
};